(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-slider"] && !Shopify.designMode) return;
  try {
    
  // Global state for the shared popup
  const sliderPopupState = {
    currentImages: [],
    currentImageIndex: 0,
    currentSlick: null,
    currentAutoplayEnabled: false,
    elements: null,
  };

  function updatePopupImage(index) {
    const { currentImages, elements } = sliderPopupState;
    if (!elements || currentImages.length === 0) return;

    if (index < 0) index = currentImages.length - 1;
    if (index >= currentImages.length) index = 0;

    sliderPopupState.currentImageIndex = index;
    elements.image.src = currentImages[index];
  }

  function initPopupListeners() {
    const popup = document.querySelector('.block__img-slider-popup-main');
    if (!popup || popup.hasAttribute('data-listener-attached')) return;

    const elements = {
      main: popup,
      image: popup.querySelector('.block__img-slider-popup-image-media img'),
      close: popup.querySelector('.close-popup'),
      prev: popup.querySelector('.prev-popup'),
      next: popup.querySelector('.next-popup'),
    };

    sliderPopupState.elements = elements;

    elements.close.addEventListener('click', function () {
      elements.main.classList.remove('is-active');
      document.body.style.overflow = '';
      if (sliderPopupState.currentAutoplayEnabled && sliderPopupState.currentSlick) {
        sliderPopupState.currentSlick.slick('slickPlay');
      }
    });

    elements.prev.addEventListener('click', function () {
      updatePopupImage(sliderPopupState.currentImageIndex - 1);
    });

    elements.next.addEventListener('click', function () {
      updatePopupImage(sliderPopupState.currentImageIndex + 1);
    });

    elements.main.addEventListener('click', function (e) {
      if (e.target === elements.main) {
        elements.close.click();
      }
    });

    popup.setAttribute('data-listener-attached', 'true');
  }

  function initImageSliders() {
    initPopupListeners();

    const mainSliders = document.querySelectorAll('.block__img-slider-main');

    mainSliders.forEach(function (sliderSection) {
      if (sliderSection.classList.contains('is-initialized')) return;

      const slickContainer = sliderSection.querySelector('.block__img-slider-wrapper');
      if (!slickContainer) return;

      const autoplayEnabled = sliderSection.getAttribute('data-autoplay') === 'true';
      const autoplayDelay = parseInt(sliderSection.getAttribute('data-delay')) || 3000;
      const direction = sliderSection.getAttribute('data-direction') || 'ltr';

      const slickOptions = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        rtl: direction === 'rtl',
        autoplay: autoplayEnabled,
        autoplaySpeed: autoplayDelay,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      };

      if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
        const $slick = jQuery(slickContainer).slick(slickOptions);
        sliderSection.classList.add('is-initialized');

        const slideLinks = sliderSection.querySelectorAll('.block__img-slider-image');
        const sectionImages = Array.from(slideLinks).map((el) => el.getAttribute('data-src'));

        slideLinks.forEach((link, index) => {
          link.addEventListener('click', function (e) {
            e.preventDefault();

            // Update shared state
            sliderPopupState.currentImages = sectionImages;
            sliderPopupState.currentImageIndex = index;
            sliderPopupState.currentSlick = $slick;
            sliderPopupState.currentAutoplayEnabled = autoplayEnabled;

            $slick.slick('slickPause');
            updatePopupImage(index);

            // Set direction for shared popup
            sliderPopupState.elements.main.setAttribute('dir', direction);

            sliderPopupState.elements.main.classList.add('is-active');
            document.body.style.overflow = 'hidden';
          });
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initImageSliders);
  document.addEventListener('shopify:section:load', initImageSliders);

  } catch(e) { console.error(e); }
})();
})();
